import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Admin panel error:", error, info);
  }
  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }
  render() {
    if (this.state.error) {
      return (
        <div data-testid="panel-error" className="rounded-3xl border border-[#E5DBC8] bg-white p-10 text-center">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#FBF1EA] text-[#FBC4A8]"><AlertTriangle className="h-5 w-5" /></span>
          <h2 className="mt-4 font-display text-2xl text-[#2C2B2C]">This section hit a snag</h2>
          <p className="mt-2 text-sm text-[#8A7F86]">{String(this.state.error?.message || this.state.error)}</p>
          <button onClick={() => this.setState({ error: null })} className="mt-5 rounded-full bg-[#232222] px-6 py-2.5 text-xs uppercase tracking-wider text-[#F5EFE3]">Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
